import { Card } from "react-bootstrap";

import { FileRow } from "../../../common/components";
import { InvoiceState } from "../../../types/invoice";
import styled from "styled-components";

type InvoiceFilesCardProps = {
    className?: string;
    invoice: InvoiceState;
    developerAccountName?: string;
    contractorAccountName?: string;
};

const InvoiceFilesCard = ({
    className,
    invoice,
    developerAccountName,
    contractorAccountName,
}: InvoiceFilesCardProps): JSX.Element => {
    return (
        <Card className={`mb-5 border-0 ${className || ""}`}>
            <Card.Header className="border-bottom-0 p-0 pb-3">
                <StyledDt>Invoices</StyledDt>
            </Card.Header>
            <Card.Body className="pt-0">
                {invoice.props.documents.map((file, index) => (
                    <dd>
                        <FileRow
                            key={index}
                            file={file}
                            canDownload
                            downloadMeta={{
                                developerAccountName,
                                contractorAccountName,
                            }}
                        />
                    </dd>
                ))}
            </Card.Body>
        </Card>
    );
};

const StyledDt = styled.dt`
    margin: 0;
    color: var(--bs-body-color);
    font-size: 1.125rem;
    font-weight: 400;
    line-height: 1.5;
`;

export default InvoiceFilesCard;
